"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var fb_like_1 = __importDefault(require("./fb-like"));
var web_view_service_1 = __importDefault(require("../../services/web-view.service"));
var constants_1 = require("../../shared/constants");
var lang_service_1 = __importDefault(require("../../services/lang.service"));
var Sharer = function (_a) {
    var href = _a.href, location = _a.location;
    var triggerShareEvent = function () {
        web_view_service_1.default.sendEvent({ name: 'shareSomething', payload: "https://".concat(constants_1.prodServerRootUrl).concat(href || '').concat(location.search) });
    };
    return (web_view_service_1.default.isWebView()
        ? react_1.default.createElement("button", { className: "sharer__btn", onClick: triggerShareEvent },
            react_1.default.createElement("span", { className: "icon icon-share" }),
            lang_service_1.default.getLabel('share'))
        : react_1.default.createElement(fb_like_1.default, { href: href, queryParams: location.search }));
};
exports.default = (0, react_router_dom_1.withRouter)(Sharer);
